import AppFunctions from '../helpers/AppFunctions'

export default {
  data() {
    return {
      // Newest first. Text (title / body) lives in i18n/store/{en,th}.json under Blog.posts.<id>
      blogPosts: [
        {
          id: '3',
          img: require(`../assets/images/Newlandindpage/blog/post_03/Mobility.jpeg`),
          imgdetail: require(`../assets/images/Newlandindpage/blog/post_03/Mobility.jpeg`),
          publishedAt: '1-3 July 2026',
          categories: ['Company'],
          tags: ['Mobility Tech Asia 2026', 'Battery Swapping', 'Smart Charging']
        },
        {
          id: '2',
          img: require(`../assets/images/Newlandindpage/blog/post_02/MOU.jpeg`),
          imgdetail: require(`../assets/images/Newlandindpage/blog/post_02/MOU.jpeg`),
          publishedAt: '3 July 2024',
          categories: ['Company'],
          tags: ['MOU', 'Charging Consortium', 'EV Roaming']
        },
        {
          id: '1',
          img: require(`../assets/images/Newlandindpage/blog/2566-09-04 10.06.00.jpg`),
          imgdetail: require(`../assets/images/Newlandindpage/blog/2566-09-04 09.55.58.jpg`),
          publishedAt: '16 - 17 August 2023',
          categories: ['Development', 'Company', 'Marketing'],
          tags: ['EV Roaming', 'TechSauce 2023', 'Innovation']
        }
      ],
      categories: '',
      tags: '',
      AppFunctions
    }
  },
  computed: {
    posts() {
      return this.blogPosts.map((post) => {
        const body = this.$t(`Blog.posts.${post.id}.body`)
        return {
          ...post,
          title: this.$t(`Blog.posts.${post.id}.title`),
          body,
          excerpt: body.length > 100 ? `${body.slice(0, 100).trim()}..` : body
        }
      })
    }
  },
  methods: {
    blogCategories() {
      let cats = this.posts.map((item) => {
          return item.categories
        }),
        singleCatArray = AppFunctions.flatDeep(cats),
        categories = []

      singleCatArray.forEach((cat) => {
        const obj = {
          title: cat.trim(),
          slug: AppFunctions.slugify(cat),
          count: 1
        }
        const objIndex = AppFunctions.containsObject(obj, categories)
        if (objIndex !== -1) {
          const prevCount = categories[objIndex].count
          categories[objIndex] = {
            title: cat.trim(),
            slug: AppFunctions.slugify(cat),
            count: prevCount + 1
          }
        } else {
          categories.push(obj)
        }
      })

      this.categories = categories
    },
    blogTags() {
      let tags = this.posts.map((item) => {
          return item.tags
        }),
        singleTagArray = AppFunctions.flatDeep(tags),
        tagsData = []

      singleTagArray.forEach((tag) => {
        const obj = {
            title: tag.trim(),
            slug: AppFunctions.slugify(tag)
          },
          objIndex = AppFunctions.containsObject(obj, tagsData)

        if (objIndex !== -1) {
          tagsData[objIndex] = {
            title: tag.trim(),
            slug: AppFunctions.slugify(tag)
          }
        } else {
          tagsData.push(obj)
        }
      })

      this.tags = tagsData
    }
  },
  created() {
    this.blogCategories()
    this.blogTags()
  }
}
